import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { UserX } from 'lucide-react';

import { EPresence } from 'src/api/users-api';
import { useSetPresence } from 'src/services/api/users/presence';
import InlineBanner, { bannerStyles } from 'src/components/inline-banner/InlineBanner';

export default function AwayBanner() {
    const { mutate: setPresence, isLoading } = useSetPresence();
    const [dismissed, setDismissed] = useState(false);

    if (dismissed) { return null; }

    return (
        <InlineBanner
            severity="error"
            icon={<UserX size={15} />}
            title="You are currently away"
            description="Set yourself to online to start replying to leads."
            onDismiss={() => setDismissed(true)}
            actions={
                <Button
                    variant="outlined"
                    size="small"
                    className={`${bannerStyles.actionBtn} ${bannerStyles.outlined}`}
                    disabled={isLoading}
                    data-testid="away-banner-set-online"
                    onClick={() => setPresence({ presence: EPresence.ONLINE })}
                >
                    Set Online
                </Button>
            }
        />
    );
}
